module.exports = __webpack_public_path__ + "img/fun.38aef03a.svg";